import { CommonModule } from "@angular/common";
import { ComponentFactoryResolver, NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { CoreContentModule } from "@obg/ngx.core.content";
import { CompactFooterModule, ComponentFactoryService } from "@obg/ngx.ui.core";

import { ForgotPasswordEmailUiModule } from "../forgot-password-email.module";

import { SmForgotPasswordEmailContainer } from "./sm-forgot-password-email.container";

const DIRECTIVES = [SmForgotPasswordEmailContainer];

@NgModule({
	imports: [CommonModule, CoreContentModule, CompactFooterModule, ForgotPasswordEmailUiModule],
	exports: DIRECTIVES,
	declarations: DIRECTIVES,
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SmForgotPasswordEmailUiModule {
	constructor(componentFactoryService: ComponentFactoryService, resolver: ComponentFactoryResolver) {
		componentFactoryService.registerLazyLoadedResolver(resolver, SmForgotPasswordEmailContainer);
	}
}
